"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.worksIsIssue = exports.worksByExpertId = exports.stageExpertList = exports.stageExpertAdd = exports.saveExperts = exports.removeExpert = exports.noExpertList = exports.isChecked = exports.getScore = exports.getProject = exports.getNoMatchExpert = exports.getExpertCheckedInfo = exports.getBook = exports.expertList = exports.expertEdit = exports.expertAdd = exports.delWorks = exports.auditByExpertId = exports.aKeyMatchExpert = exports.ExpertById = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取专家列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var expertList = exports.expertList = function expertList(data) {
  return _api.default.request({
    url: '/user/expertList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增专家
 * @author kkdy
 * @date 2021-11-24
 * @param {any} data
 * @returns {any}
 */
var expertAdd = exports.expertAdd = function expertAdd(data) {
  return _api.default.request({
    url: '/user/saveUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑专家
 * @author kkdy
 * @date 2021-11-24
 * @param {any} data
 * @returns {any}
 */
var expertEdit = exports.expertEdit = function expertEdit(data) {
  return _api.default.request({
    url: '',
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据专家ID查询需要审核的作品ID
 * @author kkdy
 * @date 2021-11-26
 * @param {any} data
 * @returns {any}
 */
var worksByExpertId = exports.worksByExpertId = function worksByExpertId(data) {
  return _api.default.request({
    url: '/matchWorksScore/getListByExpertId',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取承诺书列表
 * @author kkdy
 * @date 2022-01-07
 * @param {any} data
 * @returns {any}
 */
var getBook = exports.getBook = function getBook(data) {
  return _api.default.request({
    url: '/expert/getExpertAuthenticationVOs',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取未分配的专家
 * @author kkdy
 * @date 2021-12-03
 * @param {any} data
 * @returns {any}
 */
var noExpertList = exports.noExpertList = function noExpertList(data) {
  return _api.default.request({
    url: '/matchWorksScore/getNotAssignExpertList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取阶段分配专家的列表
 * @author kkdy
 * @date 2021-12-04
 * @param {any} data
 * @returns {any}
 */
var stageExpertList = exports.stageExpertList = function stageExpertList(data) {
  return _api.default.request({
    url: '/matchStageExpert/getMatchStageExpertList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 插入手动分配的专家
 * @author kkdy
 * @date 2021-12-04
 * @param {any} data
 * @returns {any}
 */
var stageExpertAdd = exports.stageExpertAdd = function stageExpertAdd(data) {
  return _api.default.request({
    url: '/matchWorksScore/handAssignExpert',
    method: 'post',
    data: data
  });
};
/**
 * 描述 一键分配专家
 * @author kkdy
 * @date 2021-12-04
 * @param {any} data
 * @returns {any}
 */
var aKeyMatchExpert = exports.aKeyMatchExpert = function aKeyMatchExpert(data) {
  return _api.default.request({
    url: '/matchWorksScore/assignExpert',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 设置作品是否发布
 * @author kkdy
 * @date 2021-12-04
 * @param {any} data
 * @returns {any}
 */
var worksIsIssue = exports.worksIsIssue = function worksIsIssue(data) {
  return _api.default.request({
    url: '/matchWorks/setPublish',
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据作品id查询已分配专家
 * @author kkdy
 * @date 2021-12-04
 * @param {any} data
 * @returns {any}
 */
var ExpertById = exports.ExpertById = function ExpertById(data) {
  return _api.default.request({
    url: '/matchWorksScore/getExpertByWorkId',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取阶段下未分配的专家
 * @author kkdy
 * @date 2021-12-04
 * @param {any} data
 * @returns {any}
 */
var getNoMatchExpert = exports.getNoMatchExpert = function getNoMatchExpert(data) {
  return _api.default.request({
    url: '/matchWorksScore/getNotAssignExpertList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 再次添加专家
 * @author kkdy
 * @date 2021-12-04
 * @param {any} data
 * @returns {any}
 */
var saveExperts = exports.saveExperts = function saveExperts(data) {
  return _api.default.request({
    url: '/matchWorksScore/insertWorksScore',
    method: 'post',
    data: data
  });
};
/**
 * 描述 专家评审删除专家
 * @author kkdy
 * @date 2021-12-04
 * @param {any} data
 * @returns {any}
 */
var removeExpert = exports.removeExpert = function removeExpert(data) {
  return _api.default.request({
    url: '/matchWorksScore/deleteById',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除作品
 * @author kkdy
 * @date 2021-12-04
 * @param {any} data
 * @returns {any}
 */
var delWorks = exports.delWorks = function delWorks(data) {
  return _api.default.request({
    url: '/matchWorks/deleteWorksById',
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据专家Id查询需要审核的作品
 * @author kkdy
 * @date 2021-12-05
 * @param {any} data
 * @returns {any}
 */
var auditByExpertId = exports.auditByExpertId = function auditByExpertId(data) {
  return _api.default.request({
    url: '/matchWorksScore/getListByExpertId',
    method: 'post',
    data: data
  });
};
/**
 * 描述 导出成绩
 * @author kkdy
 * @date 2021-12-20
 * @param {any} data
 * @returns {any}
 */
var getScore = exports.getScore = function getScore(data) {
  return _api.default.request({
    url: '/matchWorks/export',
    method: 'post',
    data: data,
    responseType: 'blob'
  });
};
/**
 * 描述 专家id查询需要审核的作品项目
 * @author kkdy
 * @date 2021-12-22
 * @param {any} data
 * @returns {any}
 */
var getProject = exports.getProject = function getProject(data) {
  return _api.default.request({
    url: '/matchWorksScore/getMatchListByExpertId',
    method: 'post',
    data: data
  });
};
/**
 * 描述 判断专家是否提交过认证资料
 * @author kkdy
 * @date 2021-12-29
 * @param {any} data
 * @returns {any}
 */
var isChecked = exports.isChecked = function isChecked(data) {
  return _api.default.request({
    url: '/expert/checkAuthentication',
    method: 'post',
    data: data
  });
};
/**
 * 描述 专家提交认证信息
 * @author kkdy
 * @date 2021-12-29
 * @param {any} data
 * @returns {any}
 */
var getExpertCheckedInfo = exports.getExpertCheckedInfo = function getExpertCheckedInfo(data) {
  return _api.default.request({
    url: '/expert/submitAuthentication',
    method: 'post',
    data: data
  });
};